import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { LookupService } from '../../../services/lookup.service';
import { LookupValueItem } from '../../../interfaces/lookup.interface';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import {
  NzFormControlComponent,
  NzFormDirective,
  NzFormItemComponent,
} from 'ng-zorro-antd/form';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzOptionComponent, NzSelectComponent } from 'ng-zorro-antd/select';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { CommonModule, DatePipe } from '@angular/common';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { BillingService } from '../../../services/billing.service';
import { MONTHS } from '../../../shared/constants/static-data.constants';
import { NzInputModule } from 'ng-zorro-antd/input';
import { UserService } from '../../../services/user.service';
import { DropdownSelectComponent } from '../../../shared/components/dropdown-select/dropdown-select.component';

@Component({
  selector: 'ppl-config-filter',
  standalone: true,
  imports: [
    ButtonComponent,
    NzColDirective,
    NzFormControlComponent,
    NzFormDirective,
    NzFormItemComponent,
    NzOptionComponent,
    NzRowDirective,
    NzSelectComponent,
    ReactiveFormsModule,
    NzAutocompleteModule,
    CommonModule,
    NzDatePickerModule,
    NzInputModule,
    DropdownSelectComponent
  ],
  templateUrl: './config-filter.component.html',
  styleUrl: './config-filter.component.css',
})
export class ConfigFilterComponent implements OnInit {
  @Input() filterFields: any[] = [];
  @Input() billingPageName: string = '';
  @Output() searchEvent = new EventEmitter<any>();
  statusList: LookupValueItem[] = [];
  claimStatusList: LookupValueItem[] = [];
  statusCodeList: LookupValueItem[] = [];
  pageId = '';
  tabId = '';
  programName!: string;
  moduleList: any;
  categoryList: any;
  billingFilterForm!: FormGroup;
  radioOptions: LookupValueItem[] = [];
  eventCodeOptions: LookupValueItem[] = [];
  mcoEntries: any[] = [];
  years: any[] = ['2025', '2026'];
  months: any[] = MONTHS;
  fileTypeList = ['CDR', 'Payment'];
  ignoreReasonList: any[] = [];
  lookupDomainList: any[] = [];
  batchDates: any;

  loopback = [
    { val: '30 days' },
    { val: '60 days' },
    { val: '90 days' },
    { val: '120 days' },
    { val: '150 days' },
    { val: '180 days' },
  ];

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private lookupService: LookupService,
    private billingService: BillingService,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    const formFields = this.filterFields.reduce((acc, f) => {
      if (f.show) {
        acc = { ...acc, [f.field]: [f.default ? f.default : null] };
      }
      return acc;
    }, {});
    this.billingFilterForm = this.fb.group(formFields);

    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.categoryList = this.lookupService.getLookupValue('config_category');
    this.moduleList = this.lookupService.getLookupValue('config_module');
    this.getDropdownValues();
  }

  getDropdownValues(){
    this.billingService.getLookupDomainDropdown(this.programName).subscribe((data:any)=>{
      this.lookupDomainList = data?.responsedata
    }) 
  }

  onInput(e: Event, fieldName: string): void {
    const value = (e.target as HTMLInputElement).value;
    console.log('on inout-----', e, fieldName, value);
    // if (fieldName === 'consumer') {
    //   this.filteredConsumers = value ? this.consumers.filter(c => c.name.toLowerCase().includes(value.toLowerCase())) : [];
    // }
  }

  search() {
    const filters = this.getFilters();
    this.searchEvent.emit(filters);
  }

  getDate(timeframe: string) {
    const days = parseInt(timeframe.split(" ")[0], 10);
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - days);
    const formattedDate = `${(currentDate.getMonth() + 1).toString().padStart(2, '0')}/${currentDate.getDate().toString().padStart(2, '0')}/${currentDate.getFullYear()}`;
    return formattedDate;
  }

  getFilters() {
    const filters = [];
    const event = this.billingFilterForm.value;

    if (event.module && event.module.trim()) {
      filters.push({
        jsonPath: 'module',
        value: event.module.trim(),
        operator: 'Equal',
      });
    }

    if (event.category && event.category.trim()) {
      filters.push({
        jsonPath: 'category',
        value: event.category.trim(),
        operator: 'Equal',
      });
    }

    if (event.configKey && event.configKey.trim()) {
      filters.push({
        jsonPath: 'configKey',
        value: event.configKey.trim(),
        operator: 'Equal',
      });
    }

    if (event.lookupValue && event.lookupValue.trim()) {
      filters.push({
        jsonPath: 'lkpValueName',
        value: event.lookupValue.trim(),
        operator: 'Equal',
      });
    }
    
    if (event.domain) {
      filters.push({
        jsonPath: 'lkpDomainName',
        value: event.domain,
        operator: 'Equal',
      });
    }

    return filters;
  }
}
